import {
  ChevronUpDownIcon,
  QuestionMarkCircleIcon
} from "@heroicons/react/24/solid";
import { AnimatePresence, motion } from "framer-motion";
import { PropsWithChildren } from "react";
import { sidebarLinkAnimation } from "../../AnimationsVariants";
import { AnimatedButton, Icon, Tooltip } from "../../../components";
import { AnimatedNavlink } from "./AnimatedNavlink";

export const AnimatedSidebarFooter = ({
  isOpen,
  onClick
}: PropsWithChildren<{
  id?: string;
  isOpen?: boolean;
  onClick?: () => void;
}>) => (
  <div className="mt-auto flex w-full cursor-pointer border-t border-opacity-darker">
    <div className="flex w-full">
      <div
        className={`flex h-full flex-1 items-center justify-between
        ${isOpen ? "flex-row" : "flex-col"}
        `}
      >
        <AnimatePresence>
          {isOpen ? (
            <AnimatedNavlink whereTo="/help" styles="w-full">
              <motion.div
                variants={sidebarLinkAnimation}
                initial="closed"
                animate="open"
                exit="closed"
                className="w-[100%]"
              >
                <AnimatedButton
                  icon={QuestionMarkCircleIcon}
                  text="Help"
                  underline={true}
                />
              </motion.div>
            </AnimatedNavlink>
          ) : (
            <AnimatedNavlink whereTo="/help" styles="w-full">
              <div className="w-full">
                <Tooltip content="Help">
                  <AnimatedButton
                    icon={QuestionMarkCircleIcon}
                    underline={true}
                    classNameButton="justify-center"
                  />
                </Tooltip>
              </div>
            </AnimatedNavlink>
          )}
        </AnimatePresence>

        <div
          className={`flex h-fit items-center 
          ${isOpen ? "w-fit justify-end" : "w-full justify-start"}`}
        >
          <div
            className={`flex w-full px-4 py-2 ${
              isOpen
                ? "w-fit items-center justify-end"
                : "w-full justify-center "
            }`}
            onClick={onClick}
          >
            <Icon
              Icon={ChevronUpDownIcon}
              classNameIcon="rotate-90 w-5 h-5 black-lighter"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);
